// 设置Token
export function setToken(token) {
	return localStorage.setItem('token', token)
}

// 获取Token
export function getToken() {
	return localStorage.getItem('token')
}

// 删除Token
export function removeToken() {
	return localStorage.removeItem('token')
}